import { useState, useEffect } from 'react';

const HR_ACCESS_KEY = 'hr_access_token';
const EXPIRATION_TIME = 60 * 60 * 1000; // 1 hour in milliseconds

export const useHRAccess = () => {
    const [isVerified, setIsVerified] = useState(() => {
        const storedTimestamp = localStorage.getItem(HR_ACCESS_KEY);
        if (storedTimestamp) {
            const timeDiff = Date.now() - parseInt(storedTimestamp, 10);
            return timeDiff < EXPIRATION_TIME;
        }
        return false;
    });

    useEffect(() => {
        // Initial check in case we need to clear expired token immediately
        checkAccess();

        // Set up an interval to periodically check/expire session
        const interval = setInterval(checkAccess, 60000); // Check every minute
        return () => clearInterval(interval);
    }, []);

    const checkAccess = () => {
        const storedTimestamp = localStorage.getItem(HR_ACCESS_KEY);
        if (storedTimestamp) {
            const timeDiff = Date.now() - parseInt(storedTimestamp, 10);
            if (timeDiff < EXPIRATION_TIME) {
                // Only update if it was false (to avoid unnecessary re-renders)
                setIsVerified(prev => prev ? prev : true);
                return;
            }
        }

        // If we reach here, either no token or expired
        setIsVerified(prev => {
            if (prev) {
                localStorage.removeItem(HR_ACCESS_KEY);
                return false;
            }
            localStorage.removeItem(HR_ACCESS_KEY);
            return false;
        });
    };

    const grantAccess = () => {
        localStorage.setItem(HR_ACCESS_KEY, Date.now().toString());
        setIsVerified(true);
    };

    const revokeAccess = () => {
        localStorage.removeItem(HR_ACCESS_KEY);
        setIsVerified(false);
    };

    return {
        isVerified,
        grantAccess,
        revokeAccess
    };
};
